const selectors = {
  emailInput: "#CustomerEmail",
  passwordInput: "#CustomerPassword",
  form: "#customer_login",
  formStatus: "#form-status--CustomerEmail",
};

class LoginForm {
  constructor() {
    this.elements = this._getElements();
    if (Object.keys(this.elements).length === 0) return;
    this._setupEventListeners();
  }

  _getElements() {
    const form = document.querySelector(selectors.form);
    return form
      ? {
        form,
        emailInput: form.querySelector(selectors.emailInput),
        passwordInput: form.querySelector(selectors.passwordInput),
      }
      : {};
  }

  _setupEventListeners() {
    this.elements.form.addEventListener("submit", this._handleFormSubmit);
  }

  _handleFormSubmit = (event) => {
    event.preventDefault();
    let formData = {};
    formData.email = this.elements.emailInput.value;
    formData.password = this.elements.passwordInput.value;

    fetch(truniagenMainApiBaseUrl + "/auth/login", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      },
      body: JSON.stringify({
        email: formData.email,
        password: formData.password,
      }),
    })
    .then((response) => response.json())
    .then((responseJson) => {
      if (responseJson.login_using_shopify) {
        event.target.submit();
      } else if (responseJson.error || responseJson.errors) {
        this.elements.form.querySelector(selectors.formStatus)?.remove();

        let formStatus = document.createElement("div");
        formStatus.id = "form-status--CustomerEmail";
        formStatus.classList.add("form-status");

        let errorMessages = []
        if (responseJson.error) {
          errorMessages.push(responseJson.error);
        } else if (responseJson.errors) {
          let fieldsNames = Object.keys(responseJson.errors)
          for (let i = 0; i < fieldsNames.length; i++) {
            let fieldErrors = responseJson.errors[fieldsNames[i]]
            for (let y = 0; y < fieldErrors.length; y++) {
              errorMessages.push(fieldErrors[y]);
            }
          }
        }

        let errorMessagesList = document.createElement("ul");
        for (let i = 0; i < errorMessages.length; i++) {
            let errorMessageListItem = document.createElement("li");
            errorMessageListItem.innerHTML = errorMessages[i];
            errorMessagesList.append(errorMessageListItem);
        }

        formStatus.innerHTML =
          '<div class="form-status__message form-status__message--error fs-body-75">'
            + errorMessagesList.innerHTML +
          '</div>';

        const form = this.elements.form;
        form.prepend(formStatus);
      } else {
        window.location.href = responseJson.multipass_url
      }

    })
    .catch((e) => {
      console.error(e);
    });
  };
}

window.addEventListener("load", () => {
  typeof LoginForm !== "undefined" && new LoginForm();
});
